var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { label, labelWithSupportingText, checkbox, supportingText, tick, tickWithLabelText, tickWithSupportingText, errorCheckbox, } from './styles';
import { LabelText } from './LabelText';
import { SupportingText } from './SupportingText';
/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/source-src-checkbox-checkbox--playground) •
 * [Design System](https://theguardian.design/2a1e5182b/p/466fad-checkbox/b/33fc2f) •
 * [GitHub](https://github.com/guardian/source/tree/main/src/core/components/checkbox) •
 * [NPM](https://www.npmjs.com/package/@guardian/src-checkbox)
 *
 * Checkboxes allow users to select multiple options from a list of individual
 * items or to indicate agreement of terms and  services.
 *
 * The following themes are supported: `default`, `brand`
 */
export const Checkbox = (_a) => {
    var { label: labelContent, checked, supporting, defaultChecked, error, indeterminate, cssOverrides } = _a, props = __rest(_a, ["label", "checked", "supporting", "defaultChecked", "error", "indeterminate", "cssOverrides"]);
    const ariaChecked = () => {
        // Note: the indeterminate prop takes precedence over the checked prop
        if (indeterminate) {
            return 'mixed';
        }
        if (checked != null) {
            return checked;
        }
        return !!defaultChecked;
    };
    const isChecked = () => {
        if (checked != null) {
            return checked;
        }
        return !!defaultChecked;
    };
    const setIndeterminate = (el) => {
        if (el) {
            el.indeterminate = !!indeterminate;
        }
    };
    const box = (_jsxs(_Fragment, { children: [_jsx("input", Object.assign({ type: "checkbox", css: (theme) => [
                    checkbox(theme.checkbox && theme),
                    error ? errorCheckbox(theme.checkbox && theme) : '',
                    cssOverrides,
                ], "aria-invalid": !!error, "aria-checked": ariaChecked(), ref: setIndeterminate, defaultChecked: defaultChecked != null ? defaultChecked : undefined, checked: checked != null ? isChecked() : undefined }, props), void 0), _jsx("span", { css: (theme) => [
                    tick(theme.checkbox && theme),
                    labelContent || supporting ? tickWithLabelText : '',
                    supporting ? tickWithSupportingText : '',
                ] }, void 0)] }, void 0));
    const labelledBox = (_jsxs("label", Object.assign({ css: (theme) => [
            label(theme.checkbox && theme),
            supporting ? labelWithSupportingText : '',
        ] }, { children: [box, supporting ? (_jsxs("div", { children: [_jsx(LabelText, Object.assign({ hasSupportingText: true }, { children: labelContent }), void 0), _jsx(SupportingText, { children: supporting }, void 0)] }, void 0)) : (_jsx(LabelText, { children: labelContent }, void 0))] }), void 0));
    return _jsx(_Fragment, { children: labelContent || supportingText ? labelledBox : box }, void 0);
};
//# sourceMappingURL=Checkbox.js.map
